// extracted by mini-css-extract-plugin
export default {"contentContainer":"client-users-content_contentContainer__u7nzS"};